import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import ErrorPage from "./pages/ErrorPage";
import BlogsPage from "./pages/BlogsPage";
import PressReleasesPage from "./pages/PressReleasesPage";
import PartnershipPage from "./pages/PartnershipPage";
import BlogInner from "./components/BlogInner";
import MyPrivacyChoicesPage from "./pages/MyPrivacyChoicesPage";
import GTMManager from "./components/GTMManager";
import { ENABLE_MY_PRIVACY_CHOICE } from "./constants/gtm";
import FreeGamesByFawesomePage from "./pages/FreeGamesByFawesome";
import FreeGamesByFawesomeInner from "./components/FreeGamesByFawesomeInner";
import AdStreamPage from "./pages/AdStreamPage";
import { useEffect } from "react";

function App() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const enableRightClick = params.get("enableRightClick") === "true";

    if (!enableRightClick) {
      const handler = (e) => e.preventDefault();
      window.addEventListener("contextmenu", handler);

      // Cleanup
      return () => {
        window.removeEventListener("contextmenu", handler);
      };
    }
  }, []);
  return (
    <>
      {ENABLE_MY_PRIVACY_CHOICE && <GTMManager />}
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<HomePage />} />
          <Route path="/blogs" element={<BlogsPage />} />
          <Route path="/errorpage" element={<ErrorPage></ErrorPage>} />
          <Route path="/blogs/:id" element={<BlogInner />} />
          <Route path="/blogs/:id/:slug" element={<BlogInner />} />
          <Route path="/partnerships" element={<PartnershipPage />} />
          <Route path="/fawesome-in-news" element={<PressReleasesPage />} />
          <Route path="/games" element={<FreeGamesByFawesomePage />} />
          <Route path="/games/:id" element={<FreeGamesByFawesomeInner />} />
          <Route
            path="/games/:id/:title"
            element={<FreeGamesByFawesomeInner />}
          />
          <Route
            path="/free-streaming-app"
            element={<AdStreamPage />}
          />
          <Route
            path="/my-privacy-choices"
            element={<MyPrivacyChoicesPage />}
          />
          <Route path="*" element={<ErrorPage></ErrorPage>} />
        </Routes>
      </Router>{" "}
    </>
  );
}

export default App;
